import React from 'react';

export const TEST_ID = 'spinner';

class Spinner extends React.Component {
  render() {
    return (
      <div>
        <div className="screen-loading" data-testid={TEST_ID}>
          <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Spinner;
